import { Injectable } from "@angular/core";

@Injectable()
export class Globals {
  contenedorVarGlobal: string = "";
  tipoFormularioVarGlobal: string = "";

  ConflictosVarGlobal: string = "";

  conflictosPreguntaGlobal: boolean = false;
  conflictosEditarConflicto: boolean = false;

  conflictosnuevoDesdeEncuesta: boolean = false;
  conflictosEditarDesdeEncuesta: boolean = false;


  ActualizarPregunta: boolean = false;
  PrincipalAdministradorpreguntas : boolean = true;

  NuevoConflicto : boolean = false;
  EditarConflicto : boolean = false;


  PreguntaActual : string = "1";
  idconflictoActual : string = "1";




  EstaAuntenticado: boolean = true;

  RutaDeRedireccion:  string = "administradorconflictos";

  CorreoUsuario:  string = "";
  IdFuncionarioTablaFuncionarios:  string = "";
  NombreCompletoUsuario:  string = "";
  SuperAdministrador:  string = "";
  IdSapFrontera:  string = "";

  lenguaje: string = "es";

  historialRespuestasSeleccionado:any;
  historialEdicionConflictos:any;
  funcionarioSeleccionado:any;
  listaPreguntas:any;
  preguntaSeleccionada;
  annioSeleccionado;
  tipoConsulta:any;

  lugarConflicto=0;


  listaConflictoSI=[]
  listaConflictosEditados=[]
  listaConflictosNoEditados=[]
}
